var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterestRate = function SvgInterestRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596379",
    d: "m18.175 9.675-5.158-5.808c-.609-.684-1.792-.684-2.4 0L8.808 5.9c.442.15.859.358 1.242.608l1.558-1.75c.142-.158.267-.158.409 0l4.175 4.692h-1.45c-.367 0-.667.3-.667.667v5.2H11.3a5.9 5.9 0 0 1-1.667 1.333h5.109c.175 0 .35-.067.475-.192a.66.66 0 0 0 .191-.475v-5.2h2.267a.667.667 0 0 0 .5-1.108"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#596379",
    d: "M12.133 11.458a5.27 5.27 0 0 0-5.266-5.266A5.27 5.27 0 0 0 1.6 11.458a5.273 5.273 0 0 0 5.267 5.267c2.9 0 5.266-2.367 5.266-5.267m-5.266 3.934a3.94 3.94 0 0 1-3.934-3.934 3.94 3.94 0 0 1 3.934-3.933 3.94 3.94 0 0 1 3.933 3.933 3.94 3.94 0 0 1-3.933 3.934"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#596379",
    d: "M5.15 9.692h.592c.533 0 .841.175.966.441H5.15v.567h1.592c-.1.35-.442.567-1.1.567H5.15v.808c.633.667 1.25 1.417 1.708 1.967H8.15c-.608-.75-1.242-1.517-1.783-2.067.766-.067 1.383-.508 1.516-1.283H8.8v-.567h-.908c-.05-.3-.159-.525-.325-.708H8.8V8.85H5.15v.842"
  })));
};
export default SvgInterestRate;